/* Phone bottom bar: shows while the real button it stands in for is off screen, and presses that button */
(function(){
  function setup(){
    if(!('IntersectionObserver' in window))return;
    document.querySelectorAll('[data-sticky]').forEach(function(bar){
      var t=document.querySelector(bar.getAttribute('data-sticky'));if(!t||bar._t===t)return;
      if(bar._io)bar._io.disconnect();bar._t=t;
      bar._io=new IntersectionObserver(function(es){bar.classList.toggle('is-on',!es[0].isIntersecting)});
      bar._io.observe(t);document.body.classList.add('has-sticky');
    });
  }
  window.mbStickySetup=setup;
  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-sticky-go]');if(!b)return;
    var bar=b.closest('[data-sticky]'),t=document.querySelector(bar.getAttribute('data-sticky-press')||bar.getAttribute('data-sticky'));
    if(t&&!t.disabled)t.click();
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup);else setup();
})();
